function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { Spacing, FieldHeight } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';
import { variant } from '@tablekit/utils';
import { ButtonSize, Appearance } from '../types.js';
import { getButtonHeight, transition, getBorderRadius, getOutlineRadius, styledComponentOptions, getLoadingStyle } from './commonStyles.js';
import { borderWidth, defaultVariants } from './themeDefinitions/index.js';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "2kcxui",
  styles: "padding:0;justify-content:center"
} : {
  name: "1tskxu4-sizeOverride",
  styles: "padding:0;justify-content:center;label:sizeOverride;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function getButtonStyles(props) {
  var _variants;

  var cursor = 'pointer';
  var width = 'auto';
  var height = getButtonHeight(props);
  var size = variant({
    prop: 'size',
    default: ButtonSize.Regular,
    variants: (_variants = {}, _defineProperty(_variants, ButtonSize.Regular, /*#__PURE__*/css(Typography.Heading4, ";padding:0 ", Spacing.L5, ";vertical-align:middle;", props.isOnlyChild ? '' : "min-width: ".concat(parseInt(FieldHeight.Regular, 10) * 3, "px"), ";& .svg-inline--fa{width:", Spacing.L4, ";height:", Spacing.L4, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Regular2, /*#__PURE__*/css(Typography.Heading4, ";padding:0 ", Spacing.L5, ";vertical-align:middle;", props.isOnlyChild ? '' : "min-width: ".concat(parseInt(FieldHeight.Regular2, 10) * 3, "px"), ";& .svg-inline--fa{width:", Spacing.L4, ";height:", Spacing.L4, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Small, /*#__PURE__*/css(Typography.Heading4, ";padding:0 ", Spacing.L4, ";vertical-align:middle;", props.isOnlyChild ? '' : "min-width: ".concat(parseInt(FieldHeight.Small, 10) * 3, "px"), ";& .svg-inline--fa{width:", Spacing.L4, ";height:", Spacing.L4, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Large, /*#__PURE__*/css(Typography.Body1, ";padding:0 ", Spacing.L5, ";vertical-align:middle;", props.isOnlyChild ? '' : "min-width: ".concat(parseInt(FieldHeight.Large, 10) * 3, "px"), ";& .svg-inline--fa{width:", Spacing.L5, ";height:", Spacing.L5, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _variants)
  })(props);
  var sizeOverride = '';

  if (props.disabled) {
    cursor = 'not-allowed';
  } // Fit to parent width


  if (props.fit) {
    width = '100%';
  } else if (props.isOnlyChild) {
    width = FieldHeight.Regular;

    if (props.size === ButtonSize.Large) {
      width = FieldHeight.Large;
    } else if (props.size === ButtonSize.Small) {
      width = FieldHeight.Small;
    } else if (props.size === ButtonSize.Regular2) {
      width = FieldHeight.Regular2;
    }

    sizeOverride = _ref;
  }

  return /*#__PURE__*/css("text-decoration:none;border-color:transparent;border-width:", borderWidth, "px;border-style:solid;align-items:baseline;box-sizing:border-box;cursor:", cursor, ";display:inline-flex;justify-content:center;margin:0;max-width:100%;outline:none;pointer-events:auto;text-align:center;white-space:nowrap;width:", width, ";height:", height, ";", size, ";", sizeOverride, ";&::-moz-focus-inner{border:0;margin:0;padding:0;}font-weight:600;", transition, ";position:relative;&:before{content:'';display:block;position:absolute;background:transparent;opacity:0;top:-", borderWidth, "px;right:-", borderWidth, "px;bottom:-", borderWidth, "px;left:-", borderWidth, "px;", transition, ";}&:after{content:'';display:block;position:absolute;top:-", borderWidth, "px;right:-", borderWidth, "px;bottom:-", borderWidth, "px;left:-", borderWidth, "px;", transition, ";}&,&:before{border-radius:", getBorderRadius(height, props.shape), ";}&:after{border-radius:", getOutlineRadius(height, props.shape), ";}", variant({
    prop: 'appearance',
    default: Appearance.Solid,
    variants: defaultVariants
  })(props), " &:focus::after{border:2px solid ", props.theme.colors.focusOutline, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getButtonStyles;"));
}

var StyledButton = /*#__PURE__*/_styled('button', process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1ulk68o2"
}, styledComponentOptions) : _extends({}, {
  target: "e1ulk68o2",
  label: "StyledButton"
}, styledComponentOptions))(getButtonStyles, ";");

var StyledLink = /*#__PURE__*/_styled('a', process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1ulk68o1"
}, styledComponentOptions) : _extends({}, {
  target: "e1ulk68o1",
  label: "StyledLink"
}, styledComponentOptions))(getButtonStyles, ";&,&:hover,&:active,&:visited{text-decoration:none;}");

var IconWrapper = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1ulk68o0"
} : {
  target: "e1ulk68o0",
  label: "IconWrapper"
})("align-items:center;justify-content:center;width:auto;height:auto;align-self:center;display:flex;flex-shrink:0;margin:0;user-select:none;", getLoadingStyle, ";");

export { IconWrapper, StyledButton, StyledLink, getButtonStyles };
